import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import TeesterIcon from '@components/Common/TeesterIcon';

import style from './style.module.css';

const Window = ({ children, onClose = () => {}, open = false, maxWidth }) => {
  const ref = useRef();
  const mouseDownTarget = useRef();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let timer = setTimeout(() => {
      setIsOpen(true);
      return () => {
        clearTimeout(timer);
      };
    }, 100);
  }, [open]);

  return (
    <div
      className={classNames(style.bgd, isOpen ? style.open : style.close)}
      onMouseUp={(event) => {
        if (mouseDownTarget.current && !ref.current.contains(mouseDownTarget.current) && !ref.current.contains(event.target)) {
          onClose();
        }
      }}
      onMouseDown={(event) => {
        mouseDownTarget.current = event.target;
      }}
    >
      <div className={style.pwindow}>
        <div style={{ maxWidth }} className={style.window} ref={ref}>
          <div className={style.closeIcon} onClick={onClose}>
            <TeesterIcon type="CROSS" />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

Window.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  title: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  // Set to true to add overflow: auto to the window
  overflowAuto: PropTypes.bool,
};

export default Window;
